import {computed} from 'vue';
import {useStore} from 'vuex';
import {companyLabels} from '@/constants/companyLabels';

/**
 * The current company's label choices, reactive to settings changes. Works on the
 * dashboard and the storefront (the settings are part of the public meta).
 */
export function useCompanyLabels() {
    const store = useStore();

    return computed(() => companyLabels(store.getters['company/defaultMeta']));
}
